export default "__VITE_ASSET__6baa701c__"